module.exports = __webpack_public_path__ + "img/c08_buildingtechashokasvirtue_Normal_ua.1579427e.webp";